import styled from 'styled-components';
import { StyledContentCard } from 'modules/intelligentInsights/stoInsights/components/common.styles';
import {
  borderRadius,
  colors,
  heading5,
  monochromeLink,
  Overline,
  spacing,
  subtitle1,
} from 'ui/theme';
import { IconButton } from 'ui/button';
import { pxToRem } from 'utils/convert';

export const STOTrendsCard = styled(StyledContentCard)`
  width: 100%;
`;

export const STOTrendsFlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const STOTrendsFlexResponsiveContainer = styled(STOTrendsFlexRowContainer)`
  @media screen and (width <= 1280px) {
    flex-direction: column;
    gap: ${spacing.double};
    width: 100%;
  }
  align-items: flex-start;
  gap: ${spacing.double};
`;

export const STOTrendsGraphWrapper = styled.div`
  flex: 2 0 0;
  width: 100%;
  max-width: none;
`;

export const STOTrendsDeltasWrapper = styled.div`
  flex: 0 0 ${pxToRem(420)};
`;

export const STOTrendsStyledLeftHeader = styled.h5`
  ${heading5};
  margin: 0;
`;

export const STOTrendsStyledRightHeader = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

export const STOTrendsExportButton = styled(IconButton)`
  margin-left: ${spacing.quarter};
  z-index: 0;
`;

export const STOTrendsDeltasGridContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  gap: ${spacing.base};
  padding: ${spacing.plusHalf};
  padding-bottom: ${spacing.half};
  background-color: ${colors.backgroundSecondary};
  border-radius: ${borderRadius.lg};
  height: 100%;
`;

export const STOTrendsDeltaContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  &:not(:last-of-type) {
    border-bottom: ${spacing.single} solid ${colors.borderPrimary};
    padding-bottom: ${spacing.half};
  }

  & > *:last-child {
    margin-top: ${spacing.half};
    margin-bottom: ${spacing.half};
  }
`;

export const STOTrendsDeltaContentTitle = styled(Overline)`
  margin: 0;
  color: ${colors.textSecondary};
`;
export const STOTrendsDeltaMovementText = styled.span`
  ${subtitle1};
`;
export const STOTrendsDeltaContentSecondary = styled(STOTrendsDeltaMovementText)`
  color: ${colors.textSecondary};
`;
export const STOTrendsDeltaLink = styled.div`
  ${monochromeLink};
  color: ${colors.textSecondary};
`;
export const STOTrendsDeltaUnscoredTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
